import React, { memo } from "react";
import TimerPopper from "./TimerPopper/index.js";
import TimerNodeIcon from "../../../assets/icons/TimerNode.js";
import { Handle, useStoreState, Position } from "react-flow-renderer";
import { EventTimer, RemaingTime } from "./styles.js";
import { useRef } from "react";
import { useState } from "react";


function getTimeInDaysHoursMinutes(data) {
  const temporizationInHours = data.expiration.number;
  const stringify = temporizationInHours === 24 ?
    temporizationInHours / 24 + ' dia' :
    temporizationInHours / 24 + ' dias';


  return { stringify };
}

const TimerEventNode = ({
  data,
  id,
  targetPosition = Position.Left,
  sourcePosition = Position.Right,
  selected,
}) => {
  const edges = useStoreState((state) => state.edges);
  const nodes = useStoreState((state) => state.nodes);

  const anchorRef = useRef(null);

  const [isModalOpen, setModalOpen] = useState(false);

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  const timer = getTimeInDaysHoursMinutes(data)



  const IconStyle = {
    width: "27px",
    height: "27px",
  };

  const HandleStyle = {
    width: "7px",
    height: "7px",
  };

  return (
    <>
      <EventTimer
        ref={anchorRef}
        onDoubleClick={handleOpen}
        className="flow_elements_node"
        data-id={id}
        status={data.status}
        selected={selected}
      >
        <TimerNodeIcon style={IconStyle} />

        <Handle
          type="source"
          position={sourcePosition}
          id="a"
          style={HandleStyle}
          isValidConnection={(e) =>
            nodes.find((item) => item.id === e.target).type === "parallelEnd" ||
              nodes.find((item) => item.id === e.target).type === "conditionalEnd"
              ? !edges.find((item) => item.source === e.source)
              : !edges.find(
                (item) => item.source === e.source || item.target === e.target
              )
          }
        />
        <Handle
          type="target"
          position={targetPosition}
          id="a"
          style={HandleStyle}
          isValidConnection={(e) =>
            nodes.find((item) => item.id === e.source).type === "parallel" ||
              nodes.find((item) => item.id === e.source).type === "conditional"
              ? true
              : !edges.find(
                (item) => item.target === e.target || item.source === e.source
              )
          }
        />

      </EventTimer>
      <RemaingTime>{timer.stringify}</RemaingTime>
      <TimerPopper
        isOpen={isModalOpen}
        onClose={handleClose}
        id={id}
        data={data}
        anchorRef={anchorRef}
      />
    </>
  );
};

export default memo(TimerEventNode);
